import * as yup from 'yup';

export const WalletAddressNameSchema = yup.object({
	walletAddressName: yup.string().required('Wallet address name is required'),
});

export type WalletAddressNameSchemaType = yup.InferType<typeof WalletAddressNameSchema>;

export type WalletAddressNameSTAGE = 'wallet-address-name' | 'otp-verification';
